/* =========================================================
   Happy Little Paws - Performance JS
   ========================================================= */
   /* =========================================================
   HLP PWA — Global state
   Capture the Android install event immediately
========================================================= */

let hlpDeferredInstallPrompt = null;
let hlpPwaInitialized = false;
let hlpPwaShowTimer = null;

const HLP_PWA_DISMISS_KEY = 'hlpInstallDismissedAt';
const HLP_PWA_DISMISS_DURATION = 14 * 24 * 60 * 60 * 1000;
const HLP_PWA_SHOW_DELAY = 5000;

const HLP_PWA_ICON =
  'https://cdn.shopify.com/s/files/1/0910/1321/8691/files/Happy_little_paws_192_x_192_px_Icon_d711a058-9cc3-437a-9fe8-f0ac151b37cc.png?v=1755589341';

/* Android / Chromium install event */
window.addEventListener('beforeinstallprompt', function (event) {
  event.preventDefault();
  hlpDeferredInstallPrompt = event;

  schedulePwaInstallPrompt();
});

/* Successful installation */
window.addEventListener('appinstalled', function () {
  hlpTrackPwaEvent('pwa_app_installed');
  clearPwaInstallInterface();
});

document.addEventListener('DOMContentLoaded', function () {
  initCollectionScroll();
  initPwaInstallButton();
  initTidioBehavior();
  initJudgeMeLinkFix();
  initJudgeMeRatingText();
  initServiceWorker();
});

/* =========================
   1) Collection scroll
   =========================
   ملاحظة:
   ألغينا setInterval + smooth loop لأنه ثقيل.
   سنكتفي بإيقاف أي سلوك تلقائي هنا حاليًا للحفاظ على الأداء.
   إذا أردت لاحقًا حركة ذكية وخفيفة نضيفها بشكل أفضل.
*/
function initCollectionScroll() {
  const list = document.querySelector('.scrolling-list');
  if (!list) return;

  list.addEventListener(
    'touchstart',
    function () {
      // intentionally left minimal for performance
    },
    { passive: true }
  );
}

/* =========================================================
   2) PWA install experience
========================================================= */

function initPwaInstallButton() {
  hlpPwaInitialized = true;
  schedulePwaInstallPrompt();
}

function schedulePwaInstallPrompt() {
  if (!hlpPwaInitialized) return;
  if (!isEligibleForPwaPrompt()) return;

  const platform = getPwaPlatform();

  /* Android button appears only after the browser confirms
     that the app can be installed */
  if (platform === 'android' && !hlpDeferredInstallPrompt) {
    return;
  }

  if (
    hlpPwaShowTimer ||
    document.querySelector('.hlp-install-container')
  ) {
    return;
  }

  hlpPwaShowTimer = window.setTimeout(function () {
    hlpPwaShowTimer = null;

    if (!isEligibleForPwaPrompt()) return;

    showPwaInstallBanner(platform);
  }, HLP_PWA_SHOW_DELAY);
}

function isEligibleForPwaPrompt() {
  if (window.Shopify && Shopify.designMode) return false;
  if (!isPwaHomepage()) return false;
  if (!window.matchMedia('(max-width: 768px)').matches) return false;
  if (isRunningAsInstalledApp()) return false;
  if (wasPwaPromptRecentlyDismissed()) return false;

  if (document.querySelector('.hlp-install-container')) {
    return false;
  }

  const platform = getPwaPlatform();

  return platform === 'ios' || platform === 'android';
}

function isPwaHomepage() {
  const path = window.location.pathname.replace(/\/+$/, '');

  return path === '' || path === '/de' || path === '/en';
}

function getPwaPlatform() {
  const userAgent =
    navigator.userAgent ||
    navigator.vendor ||
    window.opera ||
    '';

  const isModernIpad =
    navigator.platform === 'MacIntel' &&
    navigator.maxTouchPoints > 1;

  if (
    /iPad|iPhone|iPod/i.test(userAgent) ||
    isModernIpad
  ) {
    return 'ios';
  }

  if (/Android/i.test(userAgent)) {
    return 'android';
  }

  return 'other';
}

function isRunningAsInstalledApp() {
  return (
    window.navigator.standalone === true ||
    window.matchMedia('(display-mode: standalone)').matches ||
    window.matchMedia('(display-mode: fullscreen)').matches
  );
}

function wasPwaPromptRecentlyDismissed() {
  try {
    const storedValue = localStorage.getItem(
      HLP_PWA_DISMISS_KEY
    );

    if (!storedValue) return false;

    const dismissedAt = Number(storedValue);

    if (!Number.isFinite(dismissedAt)) {
      localStorage.removeItem(HLP_PWA_DISMISS_KEY);
      return false;
    }

    const stillDismissed =
      Date.now() - dismissedAt <
      HLP_PWA_DISMISS_DURATION;

    if (!stillDismissed) {
      localStorage.removeItem(HLP_PWA_DISMISS_KEY);
    }

    return stillDismissed;
  } catch (error) {
    return false;
  }
}

function rememberPwaDismissal() {
  try {
    localStorage.setItem(
      HLP_PWA_DISMISS_KEY,
      String(Date.now())
    );
  } catch (error) {
    /* Local storage may be unavailable */
  }
}

function getPwaTexts() {
  const language =
    document.documentElement.lang || 'de';

  const isEnglish = language
    .toLowerCase()
    .startsWith('en');

  if (isEnglish) {
    return {
      regionLabel: 'Install Happy Little Paws',
      install: 'Install app',
      close: 'Close install suggestion',
      iosTitle: 'Install Happy Little Paws',
      iosText:
        'Tap the Share button in your browser and then choose “Add to Home Screen”.',
      understood: 'Got it',
      closeDialog: 'Close instructions'
    };
  }

  return {
    regionLabel: 'Happy Little Paws installieren',
    install: 'App installieren',
    close: 'Installationshinweis schließen',
    iosTitle: 'Happy Little Paws installieren',
    iosText:
  'Tippen Sie auf das Teilen-Symbol und wählen Sie „Zum Home-Bildschirm“.',
    understood: 'Verstanden',
    closeDialog: 'Anleitung schließen'
  };
}

function showPwaInstallBanner(platform) {
  if (document.querySelector('.hlp-install-container')) {
    return;
  }

  const texts = getPwaTexts();

  const container = document.createElement('div');

  container.className = 'hlp-install-container';
  container.setAttribute('role', 'region');
  container.setAttribute(
    'aria-label',
    texts.regionLabel
  );

  container.innerHTML = `
    <div class="hlp-install-card">
      <button
        class="hlp-install-btn"
        type="button"
      >
        <span
          class="hlp-install-logo"
          aria-hidden="true"
        >
          <img
            src="${HLP_PWA_ICON}"
            alt=""
            width="32"
            height="32"
            decoding="async"
          >
        </span>

        <span class="hlp-install-btn__text">
          ${texts.install}
        </span>
      </button>

      <button
        class="hlp-install-close"
        type="button"
        aria-label="${texts.close}"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6 6l12 12M18 6L6 18"></path>
        </svg>
      </button>
    </div>
  `;

  document.body.appendChild(container);

  const installButton =
    container.querySelector('.hlp-install-btn');

  const closeButton =
    container.querySelector('.hlp-install-close');

  closeButton.addEventListener('click', function () {
    dismissPwaInstallBanner(true);
  });

  installButton.addEventListener('click', function () {
    hlpTrackPwaEvent('pwa_install_click', {
      platform: platform
    });

    if (platform === 'android') {
      handleAndroidPwaInstall();
      return;
    }

    if (platform === 'ios') {
      showIosInstallDialog();
    }
  });

  hlpTrackPwaEvent('pwa_install_prompt_shown', {
    platform: platform
  });
}

async function handleAndroidPwaInstall() {
  if (!hlpDeferredInstallPrompt) return;

  const promptEvent = hlpDeferredInstallPrompt;
  hlpDeferredInstallPrompt = null;

  try {
    await promptEvent.prompt();

    const result = await promptEvent.userChoice;

    if (result.outcome === 'accepted') {
      hlpTrackPwaEvent('pwa_install_accepted', {
        platform: 'android'
      });

      removePwaInstallBanner(false);
    } else {
      hlpTrackPwaEvent(
        'pwa_install_native_dismissed',
        {
          platform: 'android'
        }
      );

      dismissPwaInstallBanner(true);
    }
  } catch (error) {
    removePwaInstallBanner(true);
  }
}

function showIosInstallDialog() {
  if (
    document.querySelector(
      '.hlp-install-dialog-overlay'
    )
  ) {
    return;
  }

  const texts = getPwaTexts();

  const overlay = document.createElement('div');
  overlay.className = 'hlp-install-dialog-overlay';

  overlay.innerHTML = `
    <div
      class="hlp-install-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="hlp-install-dialog-title"
      aria-describedby="hlp-install-dialog-text"
    >
      <button
        class="hlp-install-dialog__close"
        type="button"
        aria-label="${texts.closeDialog}"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6 6l12 12M18 6L6 18"></path>
        </svg>
      </button>

      <div
        class="hlp-install-dialog__icon"
        aria-hidden="true"
      >
        <svg viewBox="0 0 24 24">
          <path d="M12 16V3"></path>
          <path d="M8 7l4-4 4 4"></path>
          <path d="M5 11v8h14v-8"></path>
        </svg>
      </div>

      <h2 id="hlp-install-dialog-title">
        ${texts.iosTitle}
      </h2>

      <p id="hlp-install-dialog-text">
        ${texts.iosText}
      </p>

      <button
        class="hlp-install-dialog__confirm"
        type="button"
      >
        ${texts.understood}
      </button>
    </div>
  `;

  document.body.appendChild(overlay);

  document.documentElement.classList.add(
    'hlp-install-dialog-open'
  );

  const closeButton = overlay.querySelector(
    '.hlp-install-dialog__close'
  );

  const confirmButton = overlay.querySelector(
    '.hlp-install-dialog__confirm'
  );

  function closeDialog() {
    overlay.remove();

    document.documentElement.classList.remove(
      'hlp-install-dialog-open'
    );

    document.removeEventListener(
      'keydown',
      handleEscape
    );
  }

  function handleEscape(event) {
    if (event.key === 'Escape') {
      closeDialog();
    }
  }

  closeButton.addEventListener(
    'click',
    closeDialog
  );

  confirmButton.addEventListener(
    'click',
    function () {
      closeDialog();
      dismissPwaInstallBanner(true);
    }
  );

  overlay.addEventListener('click', function (event) {
    if (event.target === overlay) {
      closeDialog();
    }
  });

  document.addEventListener(
    'keydown',
    handleEscape
  );

  window.setTimeout(function () {
    confirmButton.focus();
  }, 30);

  hlpTrackPwaEvent(
    'pwa_ios_instructions_opened',
    {
      platform: 'ios'
    }
  );
}

function dismissPwaInstallBanner(rememberDismissal) {
  if (rememberDismissal) {
    rememberPwaDismissal();

    hlpTrackPwaEvent('pwa_install_dismissed', {
      platform: getPwaPlatform()
    });
  }

  removePwaInstallBanner(true);
}

function removePwaInstallBanner(animate) {
  const container = document.querySelector(
    '.hlp-install-container'
  );

  if (!container) return;

  if (!animate) {
    container.remove();
    return;
  }

  container.classList.add('is-closing');

  window.setTimeout(function () {
    container.remove();
  }, 260);
}

function clearPwaInstallInterface() {
  if (hlpPwaShowTimer) {
    window.clearTimeout(hlpPwaShowTimer);
    hlpPwaShowTimer = null;
  }

  const dialog = document.querySelector(
    '.hlp-install-dialog-overlay'
  );

  if (dialog) {
    dialog.remove();
  }

  document.documentElement.classList.remove(
    'hlp-install-dialog-open'
  );

  removePwaInstallBanner(false);
}

function hlpTrackPwaEvent(eventName, details) {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: eventName,
    ...(details || {})
  });
}

/* =========================
   3) Tidio behavior
   ========================= */
function initTidioBehavior() {
  let chatReady = false;
  let retryCount = 0;
  const maxRetries = 40;
  const retryDelay = 300;

  function applyBehavior() {
    const chatLinks = document.querySelectorAll('.chat-button');

    if (!window.tidioChatApi) return;

    if (window.innerWidth <= 1024) {
      window.tidioChatApi.hide();

      window.tidioChatApi.on('close', function () {
        setTimeout(function () {
          window.tidioChatApi.hide();
        }, 200);
      });
    }

    chatLinks.forEach(function (btn) {
      if (btn.dataset.tidioBound === 'true') return;

      btn.dataset.tidioBound = 'true';
      btn.addEventListener('click', function () {
        window.tidioChatApi.show();
        window.tidioChatApi.open();
      });
    });
  }

  function waitForTidio() {
    if (window.tidioChatApi && !chatReady) {
      chatReady = true;
      window.tidioChatApi.on('ready', applyBehavior);
    } else if (!chatReady) {
      retryCount += 1;

      if (retryCount >= maxRetries) return;

      setTimeout(waitForTidio, retryDelay);
    }
  }

  window.addEventListener('load', waitForTidio);
}

/* =========================
   4) Judge.me links
   ========================= */
function initJudgeMeLinkFix() {
  function fixLinks(root) {
    if (!root) return;

    const links = root.querySelectorAll('.jdgm-testimonials-carousel a[target="_blank"]');
    if (!links.length) return;

    links.forEach(function (link) {
      link.removeAttribute('target');
      link.removeAttribute('rel');
    });
  }

  window.addEventListener('load', function () {
    const carousel = document.querySelector('.jdgm-testimonials-carousel');
    if (!carousel) return;

    fixLinks(carousel);

    document.addEventListener('shopify:section:load', function (e) {
      fixLinks(e.target);
    });

    const observer = new MutationObserver(function () {
      fixLinks(carousel);
    });

    observer.observe(carousel, {
      childList: true,
      subtree: true,
    });
  });
}

/* =========================
   5) Judge.me rating text
   ========================= */
function initJudgeMeRatingText() {
  function hasJudgeMeRatingElements() {
    return document.querySelector(
      '.jdgm-prev-badge, .jdgm-widget, .jdgm-testimonials-carousel, .jdgm-rev-widg'
    );
  }

  function updateRatingText() {
    const badges = document.querySelectorAll('.jdgm-prev-badge');

    badges.forEach(function (badge) {
      const score = badge.getAttribute('data-average-rating');
      if (!score) return;
      if (badge.querySelector('.jdgm-custom-rating')) return;

      const numericScore = Number(score);
      const formattedScore = Number.isInteger(numericScore)
        ? String(numericScore)
        : numericScore.toFixed(1).replace('.', ',');

      const text = document.createElement('span');
      text.className = 'jdgm-custom-rating';

      const lang = document.documentElement.lang || 'de';
      text.textContent = lang.startsWith('en')
        ? `${formattedScore} out of 5`
        : `${formattedScore} von 5`;

      badge.appendChild(text);
    });
  }

  window.addEventListener('load', function () {
    if (!hasJudgeMeRatingElements()) return;

    updateRatingText();
    setTimeout(updateRatingText, 1200);
    setTimeout(updateRatingText, 2500);
  });
}






